import { render, staticRenderFns } from "./user-avatar.component.vue?vue&type=template&id=231ab7c4&"
import script from "./user-avatar.component.vue?vue&type=script&lang=ts&"
export * from "./user-avatar.component.vue?vue&type=script&lang=ts&"
import style0 from "./user-avatar.component.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports